// Mapper to shadow levels
export const elevationLevel = {
  none: 0,
  s: 1,
  m: 2,
  l: 3,
  header: 4,
};
